// frontend/src/pages/Donate.js
import React from 'react';

const Donate = () => {
    return (
        <div className="container" style={{ textAlign: 'center' }}>
            <h2>Support Our Mission</h2>
            <p>
                Your generous contributions help us provide mindful education and mental health resources to children worldwide. 
                Together, we can create a future where every child has the tools to thrive—emotionally, academically, and spiritually.
            </p>

            {/* PayPal Donate Button */}
            <div className="paypal-button" dangerouslySetInnerHTML={{ __html: `
                <form action="https://www.paypal.com/donate" method="post" target="_top">
                    <input type="hidden" name="hosted_button_id" value="W4HWNQNMVYM6E" />
                    <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" 
                    title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                    <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
                </form>
            `}} />

            {/* Contact Us Section */}
            <h2>Contact Us</h2>
            <p>
                Have questions? Send us an email at <a href="mailto:contact@unfamiliarlearning.org" style={{ fontWeight: 'bold', color: '#006400' }}>contact@unfamiliarlearning.org</a>.
            </p>
        </div>
    );
};

export default Donate;